import React from 'react'
import { Box } from '@mui/material'
import { sanitize } from 'dompurify'

interface QuestionTextCellProps {
  questionText: string
}

const QuestionTextCell = ({ questionText }: QuestionTextCellProps) => {
  const sanitizedHTML = sanitize(questionText, {
    ALLOWED_TAGS: ['p', 'span'],
    ALLOWED_ATTR: ['style'],
  })

  if (!sanitizedHTML || sanitizedHTML.trim() === '') {
    return null
  }

  return (
    <Box
      dangerouslySetInnerHTML={{
        __html: sanitizedHTML,
      }}
    />
  )
}

export default QuestionTextCell
